<template>
    <div class="sidebar">
        <div v-if="userIsCommonLinkUser()">
            <div class="nav">
                <div class="nav-item">
                    <a v-if="generalWorkTimerLoaded && (!generalWorkTimer || (generalWorkTimer && !generalWorkTimer.is_active))" class="nav-link overflow-ellipsis" href @click="generalWorkTimerStart">
                        <span class="material-icons-outlined icons-xs icons-v-align-middle mb-1" style="margin-left: 0.5px; margin-right: 10px;">timer</span>
                        {{ trans('timers.actions.start_work') }}
                        <span class="ml-1">{{ printGeneralWorkTimer }}</span>
                    </a>
                    <a v-if="generalWorkTimerLoaded && generalWorkTimer && generalWorkTimer.is_active" class="nav-link overflow-ellipsis" href @click="generalWorkTimerStop">
                        <span class="material-icons-outlined icons-xs icons-v-align-middle mb-1" style="margin-left: 0.5px; margin-right: 10px;">timer_off</span>
                        {{ trans('timers.actions.stop_work') }}
                        <span class="ml-1">{{ printGeneralWorkTimer }}</span>
                    </a>
                    <div v-if="!generalWorkTimerLoaded">
                        <!-- Used for spacing -->
                        <icon :icon="'fas fa-stopwatch invisible'" style="margin-bottom: 27px;"></icon>
                    </div>
                </div>
            </div>
            <hr class="m-0">
        </div>
        <nav class="sidebar-nav">
            <ul class="nav">
                <li class="nav-item">
                    <router-link :to="'/dashboard'" class="nav-link overflow-ellipsis">
                        <i class="fa fa-home"></i>
                        {{ trans('sidebar.dashboard') }}
                    </router-link>
                </li>
                <li class="nav-item">
                    <router-link :to="'/projects'" class="nav-link overflow-ellipsis">
                        <i class="far fa-list-alt" aria-hidden="true"></i>
                        {{ trans('sidebar.projects') }}
                    </router-link>
                </li>
                <li class="nav-item">
                    <router-link :to="'/tasks'" class="nav-link overflow-ellipsis">
                        <i class="fa fa-tasks"></i>
                        {{ trans('sidebar.tasks') }}
                    </router-link>
                </li>
                <li class="nav-item" v-if="userCan('duties.menu') && systemHasClOnlyFeatures()">
                    <router-link :to="'/duties/users'" class="nav-link overflow-ellipsis">
                        <i class="fa fa-list-alt"></i>
                        {{ trans('sidebar.duties') }}
                    </router-link>
                </li>
                <li class="nav-item" v-if="userCanInAnyProject('projects.rma.menu') && systemHasClOnlyFeatures()">
                    <router-link :to="'/rma'" class="nav-link">
                        <i class="fas fa-tools"></i>
                        {{ trans('rma.rma') }}
                    </router-link>
                </li>
                <li v-if="userCan('projects.project_planning.menu')" class="nav-item">
                    <router-link :to="'/project-planning'" class="nav-link overflow-ellipsis">
                        <i class="fa fa-list"></i>
                        {{ trans('sidebar.project_planning') }}
                    </router-link>
                </li>
                <li v-if="userCan('projects.workload_planning.menu')" class="nav-item">
                    <router-link :to="'/workload-planning'" class="nav-link overflow-ellipsis">
                        <i class="fa fa-list-ul"></i>
                        {{ trans('sidebar.workload_planning') }}
                    </router-link>
                </li>
                <li v-if="userCanInAnyProject('projects.documents.view')" class="nav-item">
                    <router-link :to="'/documents'" class="nav-link overflow-ellipsis">
                        <i class="fa fa-file-contract"></i>
                        {{ trans('sidebar.documents') }}
                    </router-link>
                </li>
                <li v-if="userCanInAnyProject('reports.time_tracking')
                    || userCan('reports.feedback')
                    || userCan('reports.release-preparation')
                    || userCan('reports.task-distribution.view')"
                    class="nav-item nav-dropdown active">
                    <a class="nav-link overflow-ellipsis nav-dropdown-toggle" href="#" @click="handleClick">
                        <i class="fa fa-chart-line"></i>
                        {{ trans('sidebar.reports') }}
                    </a>
                    <ul class="nav-dropdown-items">
                        <li class="nav-item" v-if="userCanInAnyProject('reports.time_tracking')">
                            <router-link :to="'/reports/time-tracking/config'" class="nav-link overflow-ellipsis">
                                <i class="fa fa-clock" aria-hidden="true"></i>
                                {{ trans('sidebar.time_tracking') }}
                            </router-link>
                        </li>
                        <li class="nav-item" v-if="userCan('reports.feedback')">
                            <router-link :to="'/reports/task-feedback/config'" class="nav-link overflow-ellipsis">
                                <i class="fa fa-thumbs-up" aria-hidden="true"></i>
                                {{ trans('sidebar.satisfaction') }}
                            </router-link>
                        </li>
                        <li class="nav-item" v-if="userCan('reports.release-preparation')">
                            <router-link :to="'/reports/release-preparation/config'" class="nav-link overflow-ellipsis">
                                <i class="fa fa-check-double" aria-hidden="true"></i>
                                {{ trans('sidebar.release_reparation') }}
                            </router-link>
                        </li>
                        <li class="nav-item" v-if="userCan('reports.task-distribution.view')">
                            <router-link :to="'/reports/task-distribution/config'" class="nav-link overflow-ellipsis">
                                <i class="fa fa-chart-pie" aria-hidden="true"></i>
                                {{ trans('sidebar.task_distribution') }}
                            </router-link>
                        </li>
                        <li v-if="userCan('reports.work-report')" class="nav-item nav-dropdown active">
                            <a class="nav-link overflow-ellipsis nav-dropdown-toggle" href="#" @click="handleClick">
                                <i class="fa fa-briefcase"></i>
                                {{ trans('sidebar.work_reports') }}
                            </a>
                            <ul class="nav-dropdown-items">
                                <li class="nav-item" v-if="userCan('reports.work-report')">
                                    <router-link :to="'/reports/work-report/employee'" class="nav-link overflow-ellipsis">
                                        <i class="fa fa-users" aria-hidden="true"></i>
                                        {{ trans('sidebar.work_report_employee') }}
                                    </router-link>
                                </li>
                                <li class="nav-item" v-if="userCan('reports.work-report')">
                                    <router-link :to="'/reports/work-report/project'" class="nav-link overflow-ellipsis">
                                        <i class="far fa-list-alt" aria-hidden="true"></i>
                                        {{ trans('sidebar.work_report_project') }}
                                    </router-link>
                                </li>
                            </ul>
                        </li>
                        <li class="nav-item" v-if="userCan('reports.ratio-report.view') && systemHasClOnlyFeatures()">
                            <router-link :to="'/reports/ratio-report/config'" class="nav-link overflow-ellipsis">
                                <i class="fa fa-table" aria-hidden="true"></i>
                                {{ trans('sidebar.ratio_report') }}
                            </router-link>
                        </li>
                    </ul>
                </li>

                <li v-if="userCan('accounting.menu')" class="nav-item nav-dropdown active">
                    <a class="nav-link overflow-ellipsis nav-dropdown-toggle" href="#" @click="handleClick">
                        <i class="fa fa-calculator"></i>
                        {{ trans('sidebar.accounting') }}
                    </a>
                    <ul v-if="userCan('accounting.invoice_preparation')" class="nav-dropdown-items">
                        <li class="nav-item">
                            <router-link :to="'/accounting/invoice-preparation'" class="nav-link overflow-ellipsis">
                                <i class="fa fa-receipt" aria-hidden="true"></i>
                                {{ trans('sidebar.invoice_preparation') }}
                            </router-link>
                        </li>
                    </ul>
                    <ul v-if="userCan('accounting.invoice_issuing')" class="nav-dropdown-items">
                        <li class="nav-item">
                            <router-link :to="'/accounting/invoice-issuing'" class="nav-link overflow-ellipsis">
                                <i class="fa fa-file-invoice" aria-hidden="true"></i>
                                {{ trans('sidebar.invoice_issuing') }}
                            </router-link>
                        </li>
                    </ul>
                    <ul v-if="userCan('accounting.invoice_completion')" class="nav-dropdown-items">
                        <li class="nav-item">
                            <router-link :to="'/accounting/invoice-completion'" class="nav-link overflow-ellipsis">
                                <i class="fa fa-file-invoice-dollar" aria-hidden="true"></i>
                                {{ trans('sidebar.invoice_completion') }}
                            </router-link>
                        </li>
                    </ul>
                </li>

                <li class="nav-item" v-if="userCan('calendar.view')">
                    <router-link :to="'/calendar'" class="nav-link overflow-ellipsis">
                        <i class="fa fa-calendar-alt" aria-hidden="true"></i>
                        {{ trans('sidebar.calendar') }}
                    </router-link>
                </li>

                <li v-if="userCan('absences.create_absences')" class="nav-item nav-dropdown active">
                    <a class="nav-link overflow-ellipsis nav-dropdown-toggle" href="#" @click="handleClick">
                        <i class="fa fa-users" aria-hidden="true"></i>
                        {{ trans('sidebar.contacts') }}
                    </a>
                    <ul class="nav-dropdown-items">
                        <li class="nav-item">
                            <router-link :to="'/contacts'" class="nav-link overflow-ellipsis">
                                <i class="fa fa-user-friends" aria-hidden="true"></i>
                                {{ trans('sidebar.contact_list') }}
                            </router-link>
                        </li>
                        <li class="nav-item">
                            <router-link :to="'/absences'" class="nav-link overflow-ellipsis">
                                <i class="fa fa-user-clock" aria-hidden="true"></i>
                                {{ trans('sidebar.absences') }}
                            </router-link>
                        </li>
                    </ul>
                </li>
                <li class="nav-item" v-else>
                    <router-link :to="'/contacts'" class="nav-link overflow-ellipsis">
                        <i class="fa fa-users"></i>
                        {{ trans('sidebar.contacts') }}
                    </router-link>
                </li>

                <li class="nav-item" v-if="userCan('telephone_list.manage')">
                    <router-link :to="'/telephone-list/list'" class="nav-link overflow-ellipsis">
                        <i class="fa fa-phone" aria-hidden="true"></i>
                        {{ trans('sidebar.telephone_list') }}
                    </router-link>
                </li>

                <li class="nav-item" v-if="userCan('notification_settings.view')">
                    <router-link :to="systemHasClOnlyFeatures() ? '/notification/service-level-agreement' : '/notification/emergency'" class="nav-link overflow-ellipsis">
                        <i class="fa fa-mail-bulk" aria-hidden="true"></i>
                        {{ trans('sidebar.notification_settings') }}
                    </router-link>
                </li>

                <li v-if="userCan('admin.menu')" class="nav-item nav-dropdown active">
                    <a class="nav-link overflow-ellipsis nav-dropdown-toggle" href="#" @click="handleClick">
                        <i class="fa fa-shield-alt"></i>
                        {{ trans('sidebar.admin') }}
                    </a>
                    <ul class="nav-dropdown-items">
                        <li class="nav-item" v-if="userCan('admin.system_settings.manage')
                            || userCan('admin.maintenance_settings.manage')">
                            <router-link v-if="!userCan('admin.system_settings.manage')"
                                         :to="'/admin/system/maintenance'"
                                         class="nav-link overflow-ellipsis">
                                <i class="fa fa-cogs" aria-hidden="true"></i>
                                {{ trans('sidebar.system_settings') }}
                            </router-link>
                            <router-link v-else
                                         :to="'/admin/system/settings'"
                                         class="nav-link overflow-ellipsis">
                                <i class="fa fa-cogs" aria-hidden="true"></i>
                                {{ trans('sidebar.system_settings') }}
                            </router-link>
                        </li>
                        <li class="nav-item" v-if="userCan('admin.project_settings.manage')">
                            <router-link :to="'/admin/project/settings'" class="nav-link overflow-ellipsis">
                                <i class="far fa-list-alt" aria-hidden="true"></i>
                                {{ trans('sidebar.project_settings') }}
                            </router-link>
                        </li>
                        <li class="nav-item" v-if="userCan('admin.task-workflows.edit')">
                            <router-link :to="'/admin/task-settings'" class="nav-link overflow-ellipsis">
                                <i class="fa fa-tasks" aria-hidden="true"></i>
                                {{ trans('sidebar.task_settings') }}
                            </router-link>
                        </li>
                        <li class="nav-item" v-if="userCan('admin.rma_settings.manage') && systemHasClOnlyFeatures()">
                            <router-link :to="'/admin/rma-settings'" class="nav-link">
                                <i class="fas fa-tools" aria-hidden="true"></i>
                                {{ trans('rma.rma_settings') }}
                            </router-link>
                        </li>
                        <li class="nav-item" v-if="userCan('admin.contact_settings.manage')">
                            <router-link :to="'/admin/contact/settings'" class="nav-link overflow-ellipsis">
                                <i class="fa fa-user-cog" aria-hidden="true"></i>
                                {{ trans('sidebar.contact_settings') }}
                            </router-link>
                        </li>
                        <li class="nav-item" v-if="userCan('admin.roles.edit')">
                            <router-link :to="'/admin/roles'" class="nav-link overflow-ellipsis">
                                <i class="fa fa-user-tag" aria-hidden="true"></i>
                                {{ trans('sidebar.roles') }}
                            </router-link>
                        </li>
                        <li class="nav-item" v-if="systemIsGlobalManagementSystem() && userCan('admin.global-notifications.manage')">
                            <router-link :to="'/admin/global-notifications'" class="nav-link overflow-ellipsis">
                                <i class="fa fa-globe-americas" aria-hidden="true"></i>
                                {{ trans('sidebar.global_notifications') }}
                            </router-link>
                        </li>
<!--                        <li class="nav-item" v-if="systemIsGlobalManagementSystem() && userCan('admin.tenant-systems.manage')">-->
<!--                            <router-link :to="'/admin/tenant-systems'" class="nav-link overflow-ellipsis">-->
<!--                                <i class="fa fa-desktop" aria-hidden="true"></i>-->
<!--                                {{ trans('sidebar.tenant_systems') }}-->
<!--                            </router-link>-->
<!--                        </li>-->
                        <li class="nav-item" v-if="userCan('admin.tenants.invite')">
                            <router-link :to="'/admin/tenants'" class="nav-link overflow-ellipsis">
                                <i class="fas fa-sitemap" aria-hidden="true"></i>
                                {{ trans('sidebar.tenants') }}
                            </router-link>
                        </li>
                        <!-- TODO what restriction? "C-L only" or "Global Management System" ? -->
                        <li class="nav-item" v-if="systemHasClOnlyFeatures() && userCan('admin.translations.manage')">
                            <router-link :to="'/admin/translations'" class="nav-link overflow-ellipsis">
                                <i class="fa fa-language" aria-hidden="true"></i>
                                {{ trans('admin.translations.translations') }}
                            </router-link>
                        </li>
                    </ul>
                </li>

                <li class="nav-item">
                    <router-link :to="'/documentations?doc'" class="nav-link overflow-ellipsis">
                        <i class="fa fa-file-alt" aria-hidden="true"></i>
                        {{ trans('sidebar.documentations') }}
                    </router-link>
                </li>

                <li class="nav-item" v-if="userCan('admin.menu')">
                    <router-link :to="'/documentations?firstStep'" class="nav-link overflow-ellipsis guide">
                        <i class="fa fa-info-circle" aria-hidden="true"></i>
                        {{ trans('sidebar.first_steps') }}
                    </router-link>
                </li>
            </ul>
            <a class="sidebar-logo not-clickable" id="sidebar-logo"></a>
        </nav>

    </div>
</template>
<script>

    import _ from 'lodash';
    import Icon from "@/components/Icons/Icon";
    import GeneralWorkTimerController from '@/services/Timers/GeneralWorkTimerController';
    import {mapActions} from 'vuex';

    export default {

        name: 'sidebar',

        components: {
            Icon,
        },

        data() {
            return {
                generalWorkTimer: null,
                generalWorkTimerCounterMinutes: 0,
                generalWorkTimerCounterHours: 0,
                generalWorkTimerCounterId: 0,
                generalWorkTimerStarted: false,
                generalWorkTimerLoaded: false,
            };
        },

        computed: {

            getUrl() {
                return this.$store.getters.sidebarLogoUrl || '';
            },

            printGeneralWorkTimer() {
                const hh = this.generalWorkTimerCounterHours.toString().padStart(2, '0');
                const mm = this.generalWorkTimerCounterMinutes.toString().padStart(2, '0');

                return `${hh}:${mm}`;
            },
        },

        mounted() {
            this.setImage();
            this.addMobileClickEvent();
            this.loadGeneralWorkTimer();

            this.$bus.$on('timers.generalWorkTimer.start', this.onGeneralWorkTimerStarted);
        },


        methods: {

            ...mapActions(['swalToast']),

            handleClick(e) {
                e.preventDefault();
                e.target.parentElement.classList.toggle('open');
            },

            setImage() {
                document.getElementById('sidebar-logo').style.backgroundImage = `url(${this.getUrl.toString()})`;
            },

            addMobileClickEvent() {
                const self = this;

                // Toggle sidebar on route click in mobile view (md)
                if (window.innerWidth < 992) {
                    $('.sidebar-nav .nav-link').not('.nav-dropdown-toggle').on('click', function () {
                        if (document.body.classList.contains('sidebar-mobile-show')) {
                            document.body.classList.toggle('sidebar-mobile-show');
                            self.hideOverlayMobileSidebarOpen();
                        }
                    });
                }
            },

            generalWorkTimerStart(e) {
                e.preventDefault();

                this.generalWorkTimerLoaded = false;
                this.stopGeneralWorkTimeCounter();

                GeneralWorkTimerController.start()
                    .then(response => {
                        const type = response.data.success ? 'success' : 'error';
                        const message = response.data.error ? response.data.error : response.data.message;

                        if (response.data.success) {
                            this.generalWorkTimer = response.data && !_.isEmpty(response.data) ? response.data : null;

                            if (this.generalWorkTimer && this.generalWorkTimer.values) {
                                this.generalWorkTimerCounterMinutes = this.generalWorkTimer.values.minutes;
                                this.generalWorkTimerCounterHours = this.generalWorkTimer.values.hours;

                                if (this.generalWorkTimer.is_active) {
                                    this.startGeneralWorkTimeCounter();
                                }
                            }
                        }

                        this.swalToast({type: type, message: message});
                    })
                    .finally(response => {
                        this.generalWorkTimerLoaded = true;
                    });
            },

            generalWorkTimerStop(e) {
                e.preventDefault();

                this.generalWorkTimerLoaded = false;
                this.stopGeneralWorkTimeCounter();

                GeneralWorkTimerController.stop()
                    .then(response => {
                        const type = response.data.success ? 'success' : 'error';
                        const message = response.data.error ? response.data.error : response.data.message;

                        if (response.data.success) {
                            this.generalWorkTimer = response.data && !_.isEmpty(response.data) ? response.data : null;

                            if (this.generalWorkTimer && this.generalWorkTimer.values) {
                                this.generalWorkTimerCounterMinutes = this.generalWorkTimer.values.minutes;
                                this.generalWorkTimerCounterHours = this.generalWorkTimer.values.hours;
                            }

                            this.$bus.$emit('timers.generalWorkTimer.stopped');
                        }

                        this.swalToast({type: type, message: message});
                    })
                    .finally(response => {
                        this.generalWorkTimerLoaded = true;
                    });
            },

            loadGeneralWorkTimer() {
                if (!(this.userIsCommonLinkUser())) {
                    return;
                }

                this.generalWorkTimerLoaded = false;

                GeneralWorkTimerController.show()
                    .then(response => {
                        this.generalWorkTimer = response.data && !_.isEmpty(response.data) ? response.data : null;
                    })
                    .finally(response => {
                        if (this.generalWorkTimer && this.generalWorkTimer.values) {
                            this.generalWorkTimerCounterMinutes = this.generalWorkTimer.values.minutes;
                            this.generalWorkTimerCounterHours = this.generalWorkTimer.values.hours;

                            if (this.generalWorkTimer.is_active) {
                                this.startGeneralWorkTimeCounter();
                            }
                        } else {
                            this.generalWorkTimerCounterMinutes = 0;
                            this.generalWorkTimerCounterHours = 0;
                        }
                        this.generalWorkTimerLoaded = true;
                    });
            },

            startGeneralWorkTimeCounter() {
                if (this.generalWorkTimerStarted) {
                    return;
                }

                this.generalWorkTimerCounterId += 1;
                this.generalWorkTimerStarted = true;
                this.updateGeneralWorkTimeCounter();
            },

            updateGeneralWorkTimeCounter() {
                const id = this.generalWorkTimerCounterId;

                setTimeout(() => {
                    if (this.generalWorkTimerStarted && this.generalWorkTimerCounterId === id) {
                        if (this.generalWorkTimerCounterMinutes === 59) {
                            this.generalWorkTimerCounterMinutes = 0;
                            this.generalWorkTimerCounterHours += 1;
                        } else {
                            this.generalWorkTimerCounterMinutes += 1;
                        }

                        this.updateGeneralWorkTimeCounter();
                    }
                }, 60000);
            },

            stopGeneralWorkTimeCounter(resetCounter = false) {
                this.generalWorkTimerStarted = false;
                if (resetCounter) {
                    this.generalWorkTimerCounterMinutes = 0;
                    this.generalWorkTimerCounterHours = 0;
                }
            },

            onGeneralWorkTimerStarted() {
                if (this.generalWorkTimerStarted || !(this.userIsCommonLinkUser())) {
                    return;
                }

                this.generalWorkTimerLoaded = false;
                this.stopGeneralWorkTimeCounter();

                GeneralWorkTimerController.start()
                    .then(response => {
                        if (response.data.success) {
                            this.generalWorkTimer = response.data && !_.isEmpty(response.data) ? response.data : null;

                            if (this.generalWorkTimer && this.generalWorkTimer.values) {
                                this.generalWorkTimerCounterMinutes = this.generalWorkTimer.values.minutes;
                                this.generalWorkTimerCounterHours = this.generalWorkTimer.values.hours;

                                if (this.generalWorkTimer.is_active) {
                                    this.startGeneralWorkTimeCounter();
                                }
                            }
                        }
                    })
                    .finally(response => {
                        this.generalWorkTimerLoaded = true;
                    });
            },
        },

        watch: {
            getUrl: function () {
                this.setImage();
            }
        },

    };
</script>

<style lang="css">
    .nav-link {
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/components/Sidebar.vue